import { useMemo, useState } from 'react';
import {
  List,
  TextField,
  FunctionField,
  useTranslate,
} from 'react-admin';
import { CustomDatagrid, CrudListActions, RowActionsMenu } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import {
  CollapsibleFilterPanel,
  FilterExpandContext,
} from '@/components/common/CollapsibleFilterPanel';
import {
  CustomTextInputFilter,
  CustomSelectInputFilter,
} from '@/components/common/CustomFilters';

export const QrCodeList = () => {
  const translate = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const filterExpandValue = useMemo(
    () => ({ expanded: filtersExpanded, setExpanded: setFiltersExpanded }),
    [filtersExpanded]
  );

  const filters = useMemo(
    () => [
      <CollapsibleFilterPanel key="filters" source="_cfp" alwaysOn alwaysVisibleCount={0}>
        <CustomTextInputFilter
          source="q"
          label={translate('common.filters.search', { _: 'Buscar' })}
          alwaysOn
        />
        <CustomSelectInputFilter
          source="status"
          label={translate('resources.qrcodes.fields.status')}
          choices={[
            { id: 'active', name: translate('common.status.active', { _: 'Activo' }) },
            { id: 'inactive', name: translate('common.status.inactive', { _: 'Inactivo' }) },
          ]}
        />
        <CustomSelectInputFilter
          source="type"
          label={translate('resources.qrcodes.fields.type')}
          choices={[
            { id: 'static', name: translate('resources.qrcodes.types.static') },
            { id: 'dynamic', name: translate('resources.qrcodes.types.dynamic') },
          ]}
        />
      </CollapsibleFilterPanel>,
    ],
    [translate]
  );

  return (
    <FilterExpandContext.Provider value={filterExpandValue}>
      <List
        sx={compactListSx}
        filters={filters}
        actions={<CrudListActions exportColumns={['qr_name', 'type', 'status', 'default_staff_name', 'deptArr', 'createdAt']} />}
        sort={{ field: 'qrcode_id', order: 'DESC' }}
        exporter={false}
      >
        <CustomDatagrid primarySource="qr_name" secondarySource="type" bulkActionButtons={false}>
          <RowActionsMenu label="" sortable={false} hasShow />
          <TextField source="qr_name" />
          <FunctionField
            source="type"
            render={(record: any) =>
              translate(`resources.qrcodes.types.${record?.type}`, { _: record?.type })
            }
          />
          <FunctionField
            source="status"
            render={(record: any) =>
              record?.status === 'active'
                ? translate('common.status.active', { _: 'Activo' })
                : translate('common.status.inactive', { _: 'Inactivo' })
            }
          />
          <TextField source="default_staff_name" sortable={false} />
          <FunctionField
            source="department_id"
            sortable={false}
            render={(record: any) =>
              Array.isArray(record?.deptArr) ? record.deptArr.join(', ') : ''
            }
          />
        </CustomDatagrid>
      </List>
    </FilterExpandContext.Provider>
  );
};

export default QrCodeList;
